import type { DocumentV1Content } from '@lumapps/medias-document/types';

import { type MediaContent, MediaSource, MediaSourceV2 } from '../types';
import { formatUrlForDownload } from './formatUrlForDownload';

/**
 * List of media sources that handle their own download logic.
 * We should not append 'contentDisposition=attachment' to these URLs.
 */
const BYPASS_DOWNLOAD_SOURCES = [
    MediaSource.GOOGLE_DRIVE,
    MediaSource.MICROSOFT,
    MediaSourceV2.GOOGLE_DRIVE,
    MediaSourceV2.MICROSOFT,
];

/**
 * Gets a forced-download URL for a media content object.
 *
 * @param media The media content object.
 * @returns A URL string, or undefined if no 'downloadUrl' exists.
 */
export const getDownloadUrl = (media: Partial<MediaContent | DocumentV1Content>): string | undefined => {
    if (!media.downloadUrl) {
        return undefined;
    }

    // If it has no source property OR it has a source that matches the bypass list
    if (!('source' in media) || !media.source || BYPASS_DOWNLOAD_SOURCES.includes(media.source)) {
        return media.downloadUrl;
    }

    return formatUrlForDownload(media.downloadUrl);
};
